import http from "@/services/http";
import { userTimeZone } from "@/utils/datetime";

/**
 * Histórico do kanban — o quadro como ficou num dia que já passou.
 *
 * Toda chamada leva o fuso de quem olha: o "dia" é o dele, não o do servidor
 * (que roda em UTC). Sem isso, uma consulta às 22h em São Paulo cairia no dia
 * seguinte. Ver EventHistoryController no backend.
 */

/**
 * O quadro de um dia (mesmo formato do `/api/events/today`).
 *
 * @param {string} date "YYYY-MM-DD", hoje ou passado
 * @returns {Promise<{success: boolean, date: string, read_only: boolean, events: object[]}>}
 */
export async function fetchKanbanDay(date) {
  const { data } = await http.get("/api/events/day", {
    params: { date, time_zone: userTimeZone() },
  });
  return data;
}

/**
 * Os dias do mês que tiveram consulta — os únicos clicáveis no calendário.
 *
 * @param {string} month "YYYY-MM"
 * @returns {Promise<string[]>} datas "YYYY-MM-DD"
 */
export async function fetchDaysWithConsultations(month) {
  const { data } = await http.get("/api/events/history/days", {
    params: { month, time_zone: userTimeZone() },
  });
  return data?.days || [];
}

/**
 * O dia com consulta mais próximo antes ou depois de `date` (as setas).
 *
 * @param {string} date "YYYY-MM-DD"
 * @param {"previous"|"next"} direction
 * @returns {Promise<string|null>} a data, ou null quando não há
 */
export async function fetchNeighborDay(date, direction) {
  const { data } = await http.get("/api/events/history/neighbor", {
    params: { date, direction, time_zone: userTimeZone() },
  });
  return data?.date ?? null;
}
